import { createMiddleware, createMetaReducer } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';

const eventsMap = {};

const gtm = GoogleTagManager();

export const gtmMetaReducer = createMetaReducer(eventsMap, gtm);
export const gtmMiddleware = createMiddleware(eventsMap, gtm);

export default gtmMiddleware;